// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__NmpJF","balls":"Loader_balls__38FLX","left-swing":"Loader_left-swing__2wj9q","right-swing":"Loader_right-swing__3ZbR1"};